export const ANNOTATION_SEARCH_PARAM = 'annotation'
export const PAGE_SEARCH_PARAM = 'page'
export const PAGE_B_SEARCH_PARAM = 'pageB'
export const PROVISION_SEARCH_PARAM = 'provision'
export const RIGHT_SIDE_DRAWER_SEARCH_PARAM = 'rsd'
export const HIGHLIGHT_SEARCH_PARAM = 'highlight'
export const CHECKLIST_SEARCH_PARAM = 'checklist'
export const CHECKLIST_FILTER_SEARCH_PARAM = 'filters'
export const CHECKLIST_QUESTION_ID_SEARCH_PARAM = 'qId'
export const INFO_PANEL_SEARCH_PARAM = 'infoPanel'
export const COMPARISON_SEARCH_PARAM = 'comparison'
export const VERSION_SEARCH_PARAM = 'version'
export const CITATION_A_SEARCH_PARAM = 'citationA'
export const CITATION_B_SEARCH_PARAM = 'citationB'
export const SHOW_VERSION_UPLOAD_SEARCH_PARAM = 'showVersionUpload'
export const AUTO_PICK_FILE_SEARCH_PARAM = 'autoPickFile'
// Letter size 8.5 x 11 in postscript units
export const DEFAULT_PAGE_DIMENSIONS = {
  width: 612,
  height: 792,
} as const
export const PROVISION_FID_PREFIX = 'fid-'
export enum RightSideDrawerOptions {
  TAG = 'tag',
  CHAT = 'chat',
}

export const TABLE_OF_CONTENTS = 'Table of contents'
export const KEY_PROVISION_MATCHES = 'Key Provision Matches'
export const KEY_PROVISION_MATCHES_SUB_TEXT =
  'Navigate key provisions found in your project documents powered by CrunchAI™'
export const KEY_PROVISION_MATCHES_LOWER = 'Key provision matches'
export const KEY_PROVISIONS_MATCHES_PLACEHOLDER = 'Search for key provisions'
export const KEY_PROVISIONS_MATCHES_DOWNLOAD = 'Key Provision'
export const AI_TEXT_IMPLEMENTATION_DATE = '2024-09-16T00:00:00+00:00'

export const LANDSCAPE = 'Landscape'
export const COMPRESS_TEXT = 'Compact'
